// =======================
// Bundle pills (select qty) + stock disable
// =======================

function isDisabledPill(pill) {
  return !pill || pill.classList.contains('is-disabled') || pill.getAttribute('aria-disabled') === 'true';
}

function getCardFromEl(el) {
  return (
    el.closest('.card') ||
    el.closest('[data-card-product]') ||
    el.closest('.product-card') ||
    el.closest('.card-wrapper')
  );
}

function setDiscOnForm(card, discCents) {
  const form = card.querySelector('form[action*="/cart/add"]');
  if (!form) return;

  // Guardamos el descuento elegido en un input hidden solo para uso futuro (display / analytics)
  let hidden = form.querySelector('input[name="properties[_bundle_disc_cents]"]');
  if (!hidden) {
    hidden = document.createElement('input');
    hidden.type = 'hidden';
    hidden.name = 'properties[_bundle_disc_cents]';
    form.appendChild(hidden);
  }
  hidden.value = String(discCents);
}

function setQtyOnForm(card, qty) {
  const form = card.querySelector('form[action*="/cart/add"]');
  if (!form) return;

  // Ensure hidden qty inside form (most reliable)
  let hidden = form.querySelector('input[name="quantity"][data-bundle-hidden]');
  if (!hidden) {
    hidden = document.createElement('input');
    hidden.type = 'hidden';
    hidden.name = 'quantity';
    hidden.setAttribute('data-bundle-hidden', 'true');
    form.appendChild(hidden);
  }
  hidden.value = String(qty);

  // Optional: sync visible readonly qty UI if you have it
  const visibleQty = card.querySelector('[data-card-qty] input[name="quantity"]');
  if (visibleQty) visibleQty.value = String(qty);
}

function getUnitPriceCents(card) {
  const el = card.querySelector('[data-unit-price-cents]');
  const cents = parseInt(el?.getAttribute('data-unit-price-cents') || '', 10);
  return Number.isFinite(cents) ? cents : null;
}

function formatMoney(cents, moneyFormat, currencySymbol) {
  // 1) Try Shopify.formatMoney (best)
  if (window.Shopify && typeof Shopify.formatMoney === 'function') {
    const out = Shopify.formatMoney(Math.round(cents), moneyFormat);

    // Si ya incluye símbolo/código, lo dejamos tal cual
    // (ej: "RM10.00", "$10.00", "10,00 €")
    if (currencySymbol && out.includes(currencySymbol)) return out;

    // Si no incluye nada visible, le anteponemos el símbolo
    if (currencySymbol) return `${currencySymbol}${out}`;
    return out;
  }

  // 2) Fallback: símbolo + número
  const num = (Math.round(cents) / 100).toFixed(2);
  return currencySymbol ? `${currencySymbol}${num}` : num;
}

function updateBundlePrices(card, qty, discCents) {
  const pricesWrap = card.querySelector('[data-bundle-prices]');
  if (!pricesWrap) return;

  const oldEl = card.querySelector('[data-bundle-old]');
  const newEl = card.querySelector('[data-bundle-new]');

  const moneyFormat =
    pricesWrap.getAttribute('data-money-format') ||
    (window.theme && theme.moneyFormat) ||
    '${{amount}}';

  const currencySymbol = pricesWrap.getAttribute('data-currency-symbol') || '';

  const unitPriceCents = getUnitPriceCents(card);
  if (unitPriceCents == null) return;

  const oldTotal = unitPriceCents * qty;

  // descuento por can en cents (editable)
  const discountedUnit = Math.max(0, unitPriceCents - discCents);
  const newTotal = discountedUnit * qty;

  if (oldEl) oldEl.textContent = formatMoney(oldTotal, moneyFormat, currencySymbol);
  if (newEl) newEl.textContent = formatMoney(newTotal, moneyFormat, currencySymbol);

  pricesWrap.hidden = false;
}

function selectPill(pill) {
  const card = getCardFromEl(pill);
  if (!card) return;

  const wrap = pill.closest('[data-card-bundle]') || card;
  const qty = Math.max(1, parseInt(pill.getAttribute('data-bundle-qty') || '1', 10));

  // UI active
  wrap.querySelectorAll('[data-bundle-qty]').forEach((btn) => {
    btn.classList.remove('is-active');
    btn.setAttribute('aria-pressed', 'false');
  });
  pill.classList.add('is-active');
  pill.setAttribute('aria-pressed', 'true');

  // set qty for add-to-cart
  setQtyOnForm(card, qty);

  // ✅ NEW: update price UI
  const discCents = Math.max(0, parseInt(pill.getAttribute('data-bundle-disc-cents') || '0', 10));
  updateBundlePrices(card, qty, discCents);
}


function disablePillsByStock(wrap) {
  const limited = wrap.getAttribute('data-stock-limited') === 'true';
  if (!limited) return;

  const available = parseInt(wrap.getAttribute('data-available') || '0', 10);
  const pills = Array.from(wrap.querySelectorAll('[data-bundle-qty]'));

  pills.forEach((btn) => {
    const q = Math.max(1, parseInt(btn.getAttribute('data-bundle-qty') || '1', 10));
    if (q > available) {
      btn.classList.add('is-disabled');
      btn.setAttribute('aria-disabled', 'true');
      btn.setAttribute('tabindex', '-1');
    } else {
      btn.classList.remove('is-disabled');
      btn.setAttribute('aria-disabled', 'false');
      btn.removeAttribute('tabindex');
    }
  });
}

function pickDefaultPill(wrap) {
  const pills = Array.from(wrap.querySelectorAll('[data-bundle-qty]'));
  if (!pills.length) return null;

  const byQty = (n) => pills.find((b) => parseInt(b.getAttribute('data-bundle-qty') || '0', 10) === n);

  // Prefer: explicit default -> qty 10 -> highest enabled -> first enabled
  let candidate = wrap.querySelector('[data-bundle-default]') || byQty(10);

  if (isDisabledPill(candidate)) {
    const enabled = pills.filter((b) => !isDisabledPill(b));
    enabled.sort((a, b) => {
      const qa = parseInt(a.getAttribute('data-bundle-qty') || '1', 10);
      const qb = parseInt(b.getAttribute('data-bundle-qty') || '1', 10);
      return qb - qa; // highest first
    });
    candidate = enabled[0] || null;
  }

  return candidate;
}

// 1) Click: ONLY select (no add to cart)
document.addEventListener('click', (e) => {
  const pill = e.target.closest('[data-bundle-qty]');
  if (!pill) return;

  // block disabled pills
  if (isDisabledPill(pill)) return;

  selectPill(pill);
});

// 2) Init: disable by stock, then select default valid pill
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-card-bundle]').forEach((wrap) => {
    disablePillsByStock(wrap);

    const candidate = pickDefaultPill(wrap);
    if (candidate) selectPill(candidate);
  });
});

// 3) Safety: block submit if qty > stock (just in case)
document.addEventListener(
  'submit',
  (e) => {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;

    const card = form.closest('.card') || form.closest('[data-card-product]') || form;
    const wrap = card.querySelector('[data-card-bundle]');
    if (!wrap) return;

    const limited = wrap.getAttribute('data-stock-limited') === 'true';
    if (!limited) return;

    const available = parseInt(wrap.getAttribute('data-available') || '0', 10);

    const qtyInput =
      form.querySelector('input[name="quantity"][data-bundle-hidden]') ||
      form.querySelector('input[name="quantity"]');

    const qty = Math.max(1, parseInt(qtyInput?.value || '1', 10));

    if (qty > available) {
      e.preventDefault();
      e.stopPropagation();
    }
  },
  true
);
